import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from './auth'

export const dictionaryApi = createApi({
  baseQuery: baseQuery(),
  reducerPath: 'dictionaryApi',
  endpoints: (builder) => ({
    getCountry: builder.query<{ results: CountryDictionary[], count: number }, DictionaryParamsInput>({
      query: ({ limit, page, ordering, search }) => ({ url: 'dictionary/country/', params: { limit, page, ordering, search } }),
    }),
    getIncoterms: builder.query<{ results: IncotermDictionary[], count: number }, DictionaryParamsInput>({
      query: ({ limit, page, ordering, search }) => ({ url: 'dictionary/incoterm/', params: { limit, page, ordering, search } }),
    }),
    getSuppliers: builder.mutation<SuppliersResponse, DictionaryParamsInput | void>({
      query: (params) => ({ url: `dictionary/v4.0/suppliers/`, params }),
    }),
    createSupplier: builder.mutation<SupplierDictionaryOutput, SupplierDictionaryInput>({
      query: (body) => ({ url: 'dictionary/v4.0/suppliers/', method: 'POST', body }),
    }),
    updateSupplier: builder.mutation<void, SupplierDictionaryOutput>({
      query: ({id, ...body}) => ({ url: `dictionary/v4.0/suppliers/${id}/`, method: 'POST', body }),
    }),
    removeSupplier: builder.mutation<void, number>({
      query: (id) => ({ url: `dictionary/v4.0/suppliers/${id}/`, method: 'DELETE' }),
    }),
    getTnvedHierarchy: builder.query<TnvedHierarchyDictionary, TnvedHierarchyInput>({
      query: ({ code, id }) => ({
        url: 'dictionary/v4.0/tnved-hierarchy/',
        params: { code, id },
      }),
    }),
    getDeclarations: builder.query<DeclarationsOutput[], DeclarationsInput>({
      query: ({ code, limit, offset }) => ({
        url: `certification/v4.0/declarations/${code}/`,
        params: { limit, offset },
      }),
    }),
  }),
})

export const {
  useLazyGetCountryQuery,
  useLazyGetIncotermsQuery,
  useLazyGetTnvedHierarchyQuery,
  useLazyGetDeclarationsQuery,
} = dictionaryApi

export const useCreateSupplierMutation = () => {
  return dictionaryApi.useCreateSupplierMutation({ fixedCacheKey: 'createSupplier' })
}

export const useUpdateSupplierMutation = () => {
  return dictionaryApi.useUpdateSupplierMutation({ fixedCacheKey: 'updateSupplier' })
}

export const useRemoveSupplierMutation = () => {
  return dictionaryApi.useRemoveSupplierMutation({ fixedCacheKey: 'removeSupplier' })
}

export const useGetSuppliersMutation = () => {
  return dictionaryApi.useGetSuppliersMutation({ fixedCacheKey: 'getSuppliers' })
}
